import { format, isBefore, parseISO, startOfDay } from 'date-fns'
import type { WebinarGroup, WebinarSession } from '../data/webinars'

export function formatSessionDate(session: WebinarSession): string {
  return format(parseISO(session.date), 'MMMM d, yyyy')
}

export function formatSessionDay(session: WebinarSession): string {
  return format(parseISO(session.date), 'EEEE')
}

export function isPastSession(
  session: WebinarSession,
  now: Date = new Date(),
): boolean {
  return isBefore(startOfDay(parseISO(session.date)), startOfDay(now))
}

/** All sessions across every group, sorted chronologically. */
export function getAllSessions(groups: WebinarGroup[]): WebinarSession[] {
  return groups
    .flatMap((group) => group.sessions)
    .slice()
    .sort((a, b) => a.date.localeCompare(b.date))
}

/** The soonest session that has not happened yet, if any. */
export function getNextSession(
  groups: WebinarGroup[],
  now: Date = new Date(),
): WebinarSession | undefined {
  return getAllSessions(groups).find((session) => !isPastSession(session, now))
}


